<template>
  <div data-page='2' class="intro page">
    <section class="hero three-quarter-height">
    </section>
    <section class="page-text row">
      <div class="hello">Hello!</div>
      <div class="col-xs-12">
        <div class="text-wrapper intro-body-text">
          <h6 class="lh-t">There are only a very few artist who have the incredible ability to move and please a crowd and bring an emotional response.  Melodie is loved for her music as much as for her personality and she is out to conquer the world with her catchy & melodic tunes.</h6>
        <p>Melodie, a well renowned international DJ & Producer has brought her sounds to the dance floors of legendary venues like “1015” San Francisco, “Ruby Skye” San Francisco, “Air 360 Sky Lounge” Ho Chi Minh City, just to name a few.  Her name appeared in line-up with famous Artist such as Paul Van Dyk, John Fleming, Dj Shogun, Protoculture, Orjan Nilsen, Kristina Sky, Aruna, Betsie Larkin, and many more.</p>
        <p>To many, Dj Melodie is more than a deejay/producer but an entertainer.  Fans are amazed and moved by her refreshing and unique style of mixing, remix and track selections. She mixes quality tracks that both excite existing fans and bring new people to the ever-changing scene. She gives off a vibe that truly depicts her emotions and love to please the crowd.  Her passion for music is clearly shown and she wants her fans to feel the same appreciation & love she has for it.  Some of the best DJs in the world are known for their skills, ability to read crowd, track selection, and performance.  It should be no surprise that Dj Melodie has all this and more.  Not only she technically skilled and a master of track selection, she has the ability to maintain ultimate control of the audience and can make them feel the music.  She connects with them and takes them on a journey into a beautiful and memorable experience.</h6>
        <p>Over the years, she has been producing, mixing, and has created a multitude of legendary mixes, remixes and songs. For Melodie, music is universal and often combines different genre such as House, Techno, and Trance together in her sets and blends them perfectly.  Her goal and dream is to create a universal sound by combining classical sounds with modern day electronic element and style.</p>
        <p>Her unique style brought her popularity across the world. Dj Melodie has always been known for getting close to her fans, as reflected by the numbers on her social media sites – in excess of eighty eight thousand followers worldwide! Her fans show their appreciation of this open exchange with their favourite artist by voting her into #27 for the Top & Best 100 Female in the world on TheFDJlist.  In 2017, she is ranking #18 in United States for Djs Top 100 Djanetop.   In the upcoming year, be on the lookout for exciting new songs; remixes, mix compilation and appearances from this DJ!</p>
        <p>“Nothing let’s me express myself better than music.  Through my work and mixes, I express Love.  That’s who I am. My goal is to bring love, joy and happiness into the hearts of everyone listening.” Says Dj Melodie. </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import UiModal from '@/components/UiModal.vue'
  import UiBaseIcon from '@/components/icons/UiBaseIcon.vue'
  import UiInputText from '@/components/UiInputText.vue'
  import UiCheckbox from '@/components/UiCheckbox.vue'
  import UiPaginationOffset from '../components/UiPaginationOffset'
  import { TimelineMax, CSSPlugin, ScrollToPlugin, Draggable } from "gsap/all"
  import _ from 'lodash'

  export default {
    name: 'IntroPage',

    components: {
      UiModal,
      UiBaseIcon,
      UiInputText,
      UiCheckbox,
      UiPaginationOffset
    },

    data () {
      return {
        title:'About Melodie',
        headline:'Melodie something',
      }
    },
    created () {
      // this.animateIn();
    },
    methods: {
      // animateIn() {
      //   let title = document.querySelector('.page-title');
      //   let headline = document.querySelector('.page-headline');
      //   let text = document.querySelector('.page-text');
      //   let media = document.querySelector('.page-media');
      //   // let bgColor = screen.getAttribute('data-bg-color');
      //   // let bg = screen.querySelector('.slide-bg');
      //   // bg.style.backgroundColor = bgColor;
      //   let timeLineIn = (new TimelineMax()
      //     .add(this.addTitle(title), 'start')
      //     .add(this.addHeadline(headline), 'start+=.3')
      //     .add(this.addText(text),'start+=.4'))
      //     .add(this.addMedia(media), 'start +=.5');
      //
      // },
      // addMedia(screen) {
      //   let tl = new TimelineMax();
      //   tl.fromTo(screen, 1, {
      //     autoAlpha: 0,
      //     x: '+100%'
      //   }, {
      //     autoAlpha: 1,
      //     x: '0%',
      //     ease: Power3.easeOut
      //   });
      //   return tl;
      // },
      // addText(screen) {
      //   let tl = new TimelineMax();
      //   tl.fromTo(screen, 1, {
      //     y: '-50%',
      //     opacity: 0,
      //   }, {
      //     y: '0%',
      //     opacity: 1,
      //     ease: Power3.easeOut,
      //   });
      //   return tl;
      // },
      // addTitle(screen) {
      //   let tl = new TimelineMax();
      //   tl.fromTo(screen, 1, {
      //     y: '-50%',
      //     opacity: 0,
      //   }, {
      //     y: '0%',
      //     opacity: 1,
      //     ease: Power3.easeOut,
      //   });
      //   return tl;
      // },
      // addHeadline(screen) {
      //   let tl = new TimelineMax();
      //   tl.fromTo(screen, 1, {
      //     y: '-50%',
      //     opacity: 0,
      //   }, {
      //     y: '0%',
      //     opacity: 1,
      //     ease: Power3.easeOut,
      //   });
      //   return tl;
      // },
    }
  }
</script>
<style lang="scss" scoped>
  .intro {

    .hero {
      background-image: url('/static/media/djmelodie-landing-page.jpg');
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
    }

    .page-text {
      text-align: left;
    }

    .hello {
      font-size: 20rem;
      font-family: $title;
      color: rgba($prime-color, .5);
      position: absolute;
    }

    .intro-body-text {
      position: relative;

      @include media_desktop {
        margin-top: 8rem;
        margin-left: 20rem;
      }

      @include media_tablet {
        margin: 0 auto;
        padding-top: 10rem;
      }
    }
  }


</style>



// WEBPACK FOOTER //
// src/pages/Intro.vue